import { ActionIcon as MantineActionIcon, createPolymorphicComponent } from '@mantine/core';
import { forwardRef } from 'react';
import { AppActionIconProps } from 'theme/components/Buttons/ActionIcon/types';

/**
 * Typed application action icon wrapper with variant and size autocomplete
 * limited to values supported by the project theme.
 */
const ActionIconBase = forwardRef<HTMLButtonElement, AppActionIconProps>(function ActionIcon(props, ref) {
  return <MantineActionIcon ref={ref} {...props} />;
});

const ActionIcon = createPolymorphicComponent<'button', AppActionIconProps>(ActionIconBase);

export default ActionIcon;

export type { AppActionIconProps as ActionIconProps } from 'theme/components/Buttons/ActionIcon/types';
export { APP_ACTION_ICON_SIZES, APP_ACTION_ICON_VARIANTS } from 'theme/components/Buttons/ActionIcon/types';
export type { AppActionIconSize, AppActionIconVariant } from 'theme/components/Buttons/ActionIcon/types';
